import React from "react";
import "./Button.css";

export default function Button(props) {
  const classes =
    props.btype === "video" ? "normal-button video-button" : "normal-button";
  return (
    <>
      <button className={classes}>{props.text}</button>
    </>
  );
}
